import { ComplementsService } from './../../services/complements/complements.service';
import { Component, OnInit, ViewChild, Injectable, Inject, Input } from '@angular/core';
import { NgbModal, NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { GeneralService } from './../../services/admin/general.service';
import { ToasterModule, ToasterService, Toast, ToasterConfig } from 'angular5-toaster';
import { CatalogsService } from './../../services/catalogs/catalogs.service';
import { StorageService } from '../../services/storage.service';
import { User } from '../../models/user';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError } from 'rxjs/operators';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/map';
import { TranslateService } from '@ngx-translate/core';
import { NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ResponseModal2Component } from './../../components/response-modal2/response-modal2.component';



const I18N_VALUES = {
  'es': {
    weekdays: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá', 'Do'],
    months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
  },
  'en': {
    weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  }
};


@Injectable()
export class I18n {
  lang; language;
  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
  ) {
    this.lang = this.storage.get('LOCAL_STORAGE');

    if (this.lang === 'es') {
      this.language = this.lang;
    } else {
      this.language = 'en';
    }
  }



}

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {

  constructor(private _i18n: I18n) {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}


@Component({
  selector: 'app-uploadcomplement',
  templateUrl: './upload-complement.component.html',
  styleUrls: ['./upload-complement.component.scss'],
  providers: [GeneralService, CatalogsService, ComplementsService,
    I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }]
})
export class UploadComplementComponent implements OnInit {
  @ViewChild('myTable') table: any;
  @Input() messages: any = {
    emptyMessage: '',
    totalMessage: '',
    selectedMessage: ''
  };
  @ViewChild('filtersCheckInv') filtersCheckInv: any;
  closeResult: string;
  public user: User;
  rol;
  proveedores;
  sociedades;
  modalFilters;
  mostrarCancelar;
  modalCargar;
  titulo;
  mensaje;
  mensaje1;
  modalRespuesta;
  complementos;
  verDetalle;
  verListado = false;
  flagDatos = false;
  flagBuscar = false;
  flagMensaje = false;
  flagBusqueda = false;
  flagOcultar;

  detalle = {
    noDocumento: '',
    fechaCarga: '',
    fechaDePago: '',
    total: '',
    moneda: '',
    sociedad: '',
    id: '',
    ordencompra: ''
  };

  estatus = 'creado';
  proveedor;
  ordenCompra;
  noDocumento;
  fechaI;
  fechaF;
  listarFacturas;
  listarFacturasTmp;
  objLength: any = [];
  rows = [];
  cantidadSeleccionada;
  importeTotal = 0;
  seleccion = false;
  proveedorFilter;
  proveedorBusqueda;
  datos;
  recargando = false;
  errorEnvioDatos;
  envioDatos;

  busy: boolean = false;
  busyBusqueda: boolean = false;
  busyCargar: boolean = false;
  busyListado: boolean = false;

  proveedores$: Observable<any>;
  proveedoresLoading = false;
  proveedorinput$ = new Subject<string>();

  toastCargarArchivos;
  public toasterconfig: ToasterConfig =
    new ToasterConfig({ timeout: 500 });

  btnFiltros;
  flagEntradas;
  toastRangoFechasValido;
  constructor(
    private translate: TranslateService,
    private general: GeneralService,
    private toasterService: ToasterService,
    private storageService: StorageService,
    private catalogo: CatalogsService,
    private complementosService: ComplementsService,
    private modalService: NgbModal
  ) {
    this.translate.get('texto.noHayInformacionLabel').subscribe(
      text => {
        this.messages.emptyMessage = text;
      });

    this.translate.get('texto.totalLabel').subscribe(
      text => {
        this.messages.totalMessage = text;
      });

    this.translate.get('texto.seleccionadoLabel').subscribe(
      text => {
        this.messages.selectedMessage = text;
      });

    this.translate.get('texto.toastCargarArchivos').subscribe(
      text => {
        this.toastCargarArchivos = text;
      });

    this.translate.get('texto.rangoFechasValido').subscribe(
      text => {
        this.toastRangoFechasValido = text;
      });

    this.translate.get('texto.tituloEnvioDatosError').subscribe(
      text => {
        this.errorEnvioDatos = text;
      });
    this.translate.get('texto.datosEnviados').subscribe(
      text => {
        this.envioDatos = text;
      });
    this.getProveedores();
  }

  ngOnInit() {
    this.noBack();
    this.modulo();
    this.user = this.storageService.getCurrentUser(); 
    this.rol = this.user.rol.id;
    //this.getSociedades();
    // this.openFilters('o');
    if (this.rol === 3) {
      this.cargarFacturas();
      this.btnFiltros = true;
      this.flagEntradas = false;
    } else {
      this.btnFiltros = false;
      this.flagEntradas = true;
    }
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  modulo() {
    this.general.serviceLog('Cargar complemento').subscribe(
      data => {
        // console.log(data);
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        }
      },
    );
  }

  getProveedores() {
    this.proveedores$ = concat(of([]),
      this.proveedorinput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),

        tap(() => this.proveedoresLoading = true),
        switchMap(term =>
          this.catalogo.obtenerProveedoresBusqueda(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => this.proveedoresLoading = false)
          ))
      )
    );
  }

  getSociedades() {
    this.catalogo.obtenerSociedades().subscribe(
      data => {
        this.sociedades = data.sapSociedad;
      },
      err => {

        // console.log(err);

      },
    );
  }

  openFilters(valor) {
    if (valor === 'o') {
      this.mostrarCancelar = false;
    } else {
      this.mostrarCancelar = true;
    }
    this.modalFilters = this.modalService.open(this.filtersCheckInv, { centered: true, keyboard: false, backdrop: 'static' });
    this.modalFilters.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      if (result === 'x') {
        this.flagMensaje = false;
      }
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReasonFiltersOC(reason)}`;
    });
  }

  private getDismissReasonFiltersOC(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  recargar() {
    this.busyListado = true;
    this.recargando = true;
    this.seleccion = false;
    this.cantidadSeleccionada = 0;
    this.importeTotal = 0;
    localStorage.removeItem('seleccion');
    this.obtenerFacturasComplementos();
  }

  cargarFacturas() {
    this.busy = true;
    this.obtenerFacturasComplementos();
  }

  obtenerFacturasComplementos() {
    localStorage.removeItem('seleccion');
    if (this.rol == 3) {
      this.proveedor = this.user.id;
    } else {
      this.proveedor = this.proveedorFilter;
    }
    /* Fecha actual */ 
    var hoy: any = new Date();
    var dd: any = hoy.getDate();
    var mm: any = hoy.getMonth() + 1;
    var yyyy = hoy.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }

    if (mm < 10) {
      mm = '0' + mm;
    }

    var fechaHoy = yyyy + '-' + mm + '-' + dd;

    /* Fecha 15 dias antes */
    let dieciseisDias = 1000 * 60 * 60 * 24 * 15;
    let resta = hoy.getTime() - dieciseisDias;
    let fechaAtras = new Date(resta);

    var ddAtras: any = fechaAtras.getDate();
    var mmAtras: any = fechaAtras.getMonth() + 1;
    var yyyyAtras: any = fechaAtras.getFullYear();

    if (ddAtras < 10) {
      ddAtras = '0' + ddAtras;
    }

    if (mmAtras < 10) {
      mmAtras = '0' + mmAtras;
    }

    var fechaAnterior = yyyyAtras + '-' + mmAtras + '-' + ddAtras;

    if (this.recargando) {
      // this.busyListado = true;
      this.objLength = []; this.rows = [];
    } else {
      //  this.busy = true;
    }

    // this.busyListado = true;
    this.complementosService.obtenerFacturas(this.proveedor, fechaAnterior, fechaHoy).subscribe(
      data => {
        this.busy = false;
        this.busyListado = false;
        this.recargando = false;
        if (data != null) {
          this.flagEntradas = false;
          this.verDetalle = true;
          this.listarFacturas = data.masterFactura;
          this.listarFacturasTmp = this.listarFacturas;

          if (this.listarFacturas.length === 0) {
            this.flagDatos = true;
            this.verListado = false;
          } else {
            this.flagDatos = false;
            this.verListado = true;
          }
        }
      },
      err => {
        this.busy = false;
        this.busyListado = false;
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  selecciones(index, row) {
    let total;
    var importeCount = 0, importe = 0;
    this.seleccion = false;
    this.objLength = [];

    if (this.listarFacturas[index].selected) {
      this.listarFacturas[index].selected = false;
    } else {
      this.listarFacturas[index].selected = true;
    }

    if (this.listarFacturas && this.listarFacturas.length > 0) {
      for (let i = 0; i < this.listarFacturas.length; i++) {
        if (this.listarFacturas[i].selected) {
          this.objLength.push(this.listarFacturas[i]);
        }
      }
    }

    var objLengthTmp = [];
    if (localStorage.getItem('seleccion') === null) {
      objLengthTmp = this.objLength; 
      localStorage.setItem('seleccion', JSON.stringify(objLengthTmp));
    } else {
      var storeSelecciones = localStorage.getItem('seleccion');
      var storeSeleccionesTmp = JSON.parse(storeSelecciones);
      var storeParse = [] = storeSeleccionesTmp;

      for (let n = 0; n < this.listarFacturas.length; n++) {
        if (this.listarFacturas[n].selected == false) {
          this.seleccion = false;
          break;
        }
      }

      if (this.listarFacturas[index].selected == false) {
        for (let k = 0; k < storeParse.length; k++) {

          var cadena1 = JSON.stringify(this.listarFacturas[index]),
            separador1 = ",",
            arregloDeSubCadenas1 = cadena1.split(separador1);
          var numSubCadenas1 = arregloDeSubCadenas1.length - 1;
          var cadenaTmp1 = [];
          var subCadenas1, cadenaFinal1 = ''
          for (var m = 0; m < numSubCadenas1; m++) {
            subCadenas1 = arregloDeSubCadenas1[m] + ',';
            cadenaFinal1 = cadenaFinal1 + subCadenas1;
          }
          cadenaTmp1.push(cadenaFinal1);
          var cadena2 = JSON.stringify(storeParse[k]),
            separador2 = ",",
            arregloDeSubCadenas2 = cadena2.split(separador2);
          var numSubCadenas2 = arregloDeSubCadenas2.length - 1;
          var cadenaTmp2 = [];
          var subCadenas2, cadenaFinal2 = ''
          for (var n = 0; n < numSubCadenas2; n++) {
            subCadenas2 = arregloDeSubCadenas2[n] + ',';
            cadenaFinal2 = cadenaFinal2 + subCadenas2;
          }
          cadenaTmp2.push(cadenaFinal2);

          if (cadenaTmp1[0] == cadenaTmp2[0]) {
            storeParse.splice(k, 1);
            storeParse = [...storeParse];
          }
        }
        localStorage.setItem('seleccion', JSON.stringify(storeParse));
      } else {
        // localStorage.setItem('seleccion', JSON.stringify(this.objLength));
        let seleccionesAlmacenadas = localStorage.getItem('seleccion');
        var st = JSON.parse(seleccionesAlmacenadas);
        var storageSelecciones = [] = st;
        var stSeleccion = [];
        storageSelecciones.push(this.listarFacturas[index]);
        localStorage.setItem('seleccion', JSON.stringify(storageSelecciones));
      }

    }

    let myItem = localStorage.getItem('seleccion');
    var storage = JSON.parse(myItem);
    var storageRows = [] = storage;

    // this.objLength = storageRows; console.log(this.objLength);
    this.rows = storageRows;
    this.cantidadSeleccionada = storageRows.length; 

    for (let j = 0; j < storageRows.length; j++) {
      importeCount = parseFloat(storageRows[j].importe);
      importe = importeCount + importe;
    }

    this.importeTotal = importe;
  }

  cambiarEstatusTodo(estado) {
    localStorage.removeItem('seleccion');

    var importeCount = 0, importe = 0;
    if (estado == true) {
      for (let i = 0; i < this.listarFacturas.length; i++) {
        this.listarFacturas[i].selected = true;
      }
    } else {
      for (let i = 0; i < this.listarFacturas.length; i++) {
        this.listarFacturas[i].selected = false;
      }
    }

    this.objLength = [];
    if (this.listarFacturas && this.listarFacturas.length > 0) {
      for (let i = 0; i < this.listarFacturas.length; i++) {
        if (this.listarFacturas[i].selected) {
          this.objLength.push(this.listarFacturas[i]);
        }
      }
    }

    localStorage.setItem('seleccion', JSON.stringify(this.objLength));
    let myItem = localStorage.getItem('seleccion');
    this.rows = this.objLength;
    this.cantidadSeleccionada = this.objLength.length;

    for (let j = 0; j < this.objLength.length; j++) {
      importeCount = parseFloat(this.objLength[j].importe);
      importe = importeCount + importe;
    }

    this.importeTotal = importe;
  }


  buscarOrdenes() {
    var enviar;
    const fechaI = (<HTMLInputElement>document.getElementById('fechaiOpt')).value;
    const fechaF = (<HTMLInputElement>document.getElementById('fechafOpt')).value;

    if (this.rol == 3) {
      this.proveedor = this.user.id;
    } else {
      this.proveedor = this.proveedorBusqueda;
    }

    if (this.proveedor == null || fechaI === '' || fechaF === '') {
      this.flagMensaje = true;
      enviar = false;
    } else {
      if (fechaI <= fechaF) {
        this.flagMensaje = false;
        enviar = true;
      } else {
        this.toasterService.pop('error', 'ERROR', this.toastRangoFechasValido);
        enviar = false;
      }
    }

    if (enviar) {
      this.busyBusqueda = true;
      this.flagEntradas = false;
      this.complementosService.obtenerFacturas(this.proveedor, fechaI, fechaF).subscribe(
        data => {
          this.busyBusqueda = false;

          this.proveedorFilter = this.proveedorBusqueda;
          if (data != null) {
            this.verDetalle = true;
            var b = data.masterFactura;

            this.listarFacturas = b;


            if (localStorage.getItem('seleccion') === null) {
              // console.log('No existe storage selecciones');
            } else {
              let myItem = localStorage.getItem('seleccion');
              var storageSelecciones = JSON.parse(myItem);

              if (storageSelecciones.length > 0) {
                var iguales = 0;
                for (var i = 0; i < b.length; i++) {
                  var totalC = JSON.stringify(b[i]).length - 1;
                  var subCadena = JSON.stringify(b[i]).substring(0, totalC);
                  subCadena = subCadena + ',';
                  // cadenaTmp = [];
                  for (var j = 0; j < storageSelecciones.length; j++) {
                    var cadena = JSON.stringify(storageSelecciones[j]),
                      separador = ",",
                      arregloDeSubCadenas = cadena.split(separador);
                    var numSubCadenas = arregloDeSubCadenas.length - 1;
                    var cadenaTmp = [];
                    var subCadenas, cadenaFinal = ''
                    for (var k = 0; k < numSubCadenas; k++) {
                      subCadenas = arregloDeSubCadenas[k] + ',';
                      cadenaFinal = cadenaFinal + subCadenas;
                    }
                    cadenaTmp.push(cadenaFinal);

                    if (subCadena == cadenaTmp[0]) {
                      this.listarFacturas[i].selected = true;
                    }
                  }
                }
              }
            }

            if (this.listarFacturas.length === 0) {
              this.flagDatos = true;
              this.verListado = false;
            } else {
              this.flagDatos = false;
              this.verListado = true;
            }
          }
          
          this.proveedorBusqueda = null;
          this.modalFilters.close();
        },
        err => {
          this.busyBusqueda = false;
          if (err.status === 401) {
            this.storageService.openLogout();
          } 
        },
      );

    }

  }

  eliminarSeleccion(rowIndex) {
    localStorage.removeItem('seleccion');
    this.rows.splice(rowIndex, 1);
    this.rows = [...this.rows];
    localStorage.setItem('seleccion', JSON.stringify(this.rows));

    let total;
    var importeCount = 0, importe = 0;

    for (let j = 0; j < this.rows.length; j++) {
      importeCount = parseFloat(this.rows[j].importe);
      importe = importeCount + importe;
    }

    this.importeTotal = importe;

    for (let k = 0; k < this.listarFacturas.length; k++) {
      this.listarFacturas[k].selected = false;
    }

    for (let i = 0; i < this.listarFacturas.length; i++) {
      for (let m = 0; m < this.rows.length; m++) {
        var cadena1 = JSON.stringify(this.listarFacturas[i]),
          separador1 = ",",
          arregloDeSubCadenas1 = cadena1.split(separador1);
        var numSubCadenas1 = arregloDeSubCadenas1.length - 1;
        var cadenaTmp1 = [];
        var subCadenas1, cadenaFinal1 = ''
        for (var l = 0; l < numSubCadenas1; l++) {
          subCadenas1 = arregloDeSubCadenas1[l] + ',';
          cadenaFinal1 = cadenaFinal1 + subCadenas1;
        }
        cadenaTmp1.push(cadenaFinal1);
        var cadena2 = JSON.stringify(this.rows[m]),
          separador2 = ",",
          arregloDeSubCadenas2 = cadena2.split(separador2);
        var numSubCadenas2 = arregloDeSubCadenas2.length - 1;
        var cadenaTmp2 = [];
        var subCadenas2, cadenaFinal2 = ''
        for (var n = 0; n < numSubCadenas2; n++) {
          subCadenas2 = arregloDeSubCadenas2[n] + ',';
          cadenaFinal2 = cadenaFinal2 + subCadenas2;
        }
        cadenaTmp2.push(cadenaFinal2);
        // console.log(cadenaTmp1[0]);
        // console.log(cadenaTmp2[0]);

        if (cadenaTmp1[0] == cadenaTmp2[0]) {
          this.listarFacturas[i].selected = true;
        }

      }
    }

    for (let n = 0; n < this.listarFacturas.length; n++) {
      if (this.listarFacturas[n].selected == false) {
        this.seleccion = false;
        break;
      }
    }


  }

  cargar(cargarArchivos) {

    this.modalCargar = this.modalService.open(cargarArchivos, { centered: true, size: 'lg', keyboard: false, backdrop: 'static' });
    this.modalCargar.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  cargaDeArchivos(file1: File, file2: File, respuesta) {
    var array: any = [];
    let flagCargar;

    if (file2) {
      flagCargar = true;
    } else {
      flagCargar = false;
    }

    const usuario: any = this.user.id;
    this.datos = JSON.stringify(this.rows);
    array.push(this.datos);
    const formData: FormData = new FormData();
    formData.append('archivoxml', file2);
    if (file1 == null || file1 == undefined) {
      formData.append('archivopdf', '');
    } else {
      formData.append('archivopdf', file1);
    }
    formData.append('proveedor', this.proveedor);
    formData.append('usuario', usuario);
    formData.append('facturas', array);

    if (flagCargar) {
      this.busyCargar = true;
      this.complementosService.postComplementos(formData).subscribe(
        data => {

          this.busyCargar = false;
          if (data != null) {
            this.modalCargar.close();

            if (data.result.status == 'S') {
              this.titulo = this.envioDatos;
            } else {
              this.titulo = this.errorEnvioDatos;
            }
            this.mensaje1 = data.result.message;

            const modalRef = this.modalService.open(ResponseModal2Component, { centered: true, keyboard: false, backdrop: 'static' });
            modalRef.componentInstance.titulo = this.titulo;
            modalRef.componentInstance.mensaje1 = this.mensaje1;

            modalRef.result.then((result) => {
              // console.log(result);

            });

            if (data.result.status == 'S') {

              this.importeTotal = 0;
              this.seleccion = false;
              this.objLength = [];
              this.rows = [];
              this.obtenerFacturasComplementos();

            }

          }

        },
        err => {
          this.busyCargar = false;
          if (err.status === 401) {
            this.storageService.openLogout();
          } 
        },
      );
    }

  }


  respuesta(respuesta) {
    this.modalRespuesta = this.modalService.open(respuesta, { centered: true, keyboard: false, backdrop: 'static' });
    this.modalRespuesta.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissR(reason)}`;
    });
  }

  private getDismissR(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/upload-complement/upload-complement.component.ts